function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15.962,
    viewBox: "0 0 16 15.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 146235",
    d: "M21-86.912a7.928 7.928 0 0 1-2.352 5.654 7.923 7.923 0 0 1-5.626 2.327h-.039a7.893 7.893 0 0 1-3.454-.8 1 1 0 0 0-.863-.01 9.749 9.749 0 0 1-3.235.813.4.4 0 0 1-.363-.172.4.4 0 0 1-.025-.4l1.175-2.33a.986.986 0 0 0-.038-.96 7.987 7.987 0 0 1-1.14-4.096 7.949 7.949 0 0 1 2.29-5.629 7.923 7.923 0 0 1 5.591-2.377 7.932 7.932 0 0 1 5.708 2.3A7.925 7.925 0 0 1 21-86.912z",
    transform: "translate(-5.001 94.893)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleChat);
export default __webpack_public_path__ + "static/media/bubble-chat.3f530a8f.svg";
export { ForwardRef as ReactComponent };